import './styles/theme.less';
import './popup.js';

document.addEventListener('DOMContentLoaded', () => {
    let menu = document.querySelector('.menu-bar');

    function setMenuScrollingClass() {
        menu.classList.toggle('scrolling', window.scrollY > 0);
    }

    window.addEventListener('scroll', setMenuScrollingClass);
    setMenuScrollingClass();

    setTimeout(() => {
        let pageLayout = document.querySelector('.page-layout');
        pageLayout.classList.remove('no-animate');
        pageLayout.classList.add('loaded');
    }, 1);
});

document.addEventListener('click', e => {
    if (!e.target.closest)
    {
        return;
    }

    let sliderPrev = e.target.closest('.slider-button-prev');
    let sliderNext = e.target.closest('.slider-button-next');
    if (sliderPrev || sliderNext)
    {
        e.preventDefault();

        let slider = (sliderPrev || sliderNext).closest('.slider');
        let items = slider.querySelector('.slider-items');
        let itemWidth = items.querySelector('.slider-item').clientWidth + 50;
        let nextScroll;
        if (sliderPrev)
        {
            nextScroll = items.scrollLeft - itemWidth;
            // if (nextScroll < itemWidth)
            // {
            //     nextScroll = 0;
            // }
        }
        else
        {
            nextScroll = items.scrollLeft + itemWidth;
            // if (nextScroll + items.clientWidth + itemWidth > items.scrollWidth)
            // {
            //     nextScroll = items.scrollWidth;
            // }
        }
        items.scrollTo({ left: nextScroll, behavior: 'smooth' });
    }
});